import React from "react";
import {SalesPackageOption} from "../../../../components/SalesPackage/SalesPackageOption";
import {SalesPackage} from "../../../../components/SalesPackage";
import {VehicleGroup} from "../../../../model/vehicle";
import {strings} from "../../../../strings/strings";
import useSwitchToNewContent from "../../../../utils/hooks/useSwitchToNewContent";

interface CascoSmartDrivePackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    totalPremium: number;
    deductible: number;
    selected: boolean;
    onSelect: () => void;
    packageName: string;
    more?: React.ReactElement;
}

export const CascoSmartDrivePackage = ({vehicleGroup, premium, deductible, selected, onSelect, packageName, more, totalPremium}: CascoSmartDrivePackage) => {
    const showNewContent = useSwitchToNewContent()

    return (
        <SalesPackage name={packageName}
                      premium={premium}
                      selected={selected}
                      onSelect={onSelect}
                      popular={false}
                      vehicleGroup={vehicleGroup}
                      more={more}
                      totalPremium={totalPremium}
                      isSmartDrive
                      >
            <SalesPackageOption name={strings.packageOptionMtplName}
                                tooltipPlacement={"left"}
                                tooltip={<ul>
                                    <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                                    <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                                </ul>}
                                covered={true}/>
            <SalesPackageOption name={strings.smartDrive.packageOptionCascoName}
                                covered={true}/>
        </SalesPackage>
    )

};